import typography from './typography';

export default {
  styleOverrides: {
    root: {
      fontFamily: typography.fontFamily
    },
  },
};
